import { gql } from '@apollo/client';

export const updateUserMutation = gql`
    mutation UpdateUser($data: UserUpdateInput!) {
        updateUser(data: $data) {
            id
            morningRitualId
            eveningRitualId
            languageCode
        }
    }
`;
